import {
  BIMComponentType,
  makeBIMComponent,
} from '@/_models/virtualStaging/BIM/component/BIM.component';
import { ComponentInteractionType } from '@/_models/virtualStaging/Scene.component';
import { LoadingState } from '@/_models/virtualStaging/VSObject';
import { initPipesAmericanWater } from '@/_models/virtualStaging/Tube';
import { pipesConfig } from '@/_models/virtualStaging/BIM/component/data';
import { createMenuItem } from '@/_models/virtualStaging/BIM/utils';

export async function buildPipes() {
  await this.showCaseTemp.showcase.Scene.register(BIMComponentType, makeBIMComponent);
  const modelNode: any = await this.showCaseTemp.mpSDK.Scene.createNode();
  const component = await modelNode.addComponent(BIMComponentType, {
    position: { x: -44.24, y: -0.1, z: 1.18 },
    rotation: { x: 0, y: -Math.PI / 2, z: 0 },
    scale: { x: 0.1, y: 0.1, z: 0.1 },
  });
  this.BIMComponent = component;
  await modelNode.start();

  component.onEvent = (type: string, eventData: any) => {
    const item = component.getItem(eventData.collider.id);
    if (!item) return;

    const selectedPipe = component.getSegmentsOfPipe(eventData.collider.name);

    if (type === ComponentInteractionType.HOVER) {
      this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? 'pointer' : 'auto';
      if (eventData.hover) {
        item.hovered = true;

        selectedPipe.forEach((segment) => {
          const segmentId = component.getSegmentIdByName(segment);
          if (segmentId) {
            component.setItemColor(segmentId, component.inputs.colorClick);
            component.setItemOpacity(segmentId, component.inputs.opacityClick);
            if (component.animatedPipes.has(segmentId)) {
              component.setAnimatedPipeOpacity(segmentId, 1);
            }
            const segmentItem = component.getItem(segmentId);
            if (segmentItem) segmentItem.hovered = true;
          }
        });
      } else {
        item.hovered = false;
        if (item.selected === true) return;
        selectedPipe.forEach((segment) => {
          const segmentId = component.getSegmentIdByName(segment);
          if (segmentId) {
            component.setItemColor(segmentId, component.inputs.colorDefault);
            component.setItemOpacity(segmentId, component.inputs.opacityDefault);
            if (component.animatedPipes.has(segmentId)) {
              component.setAnimatedPipeOpacity(segmentId, 0);
            }
            const segmentItem = component.getItem(segmentId);
            if (segmentItem) segmentItem.hovered = false;
          }
        });
      }
    }

    if (type === ComponentInteractionType.CLICK) {
      if (component.selectedPipe) {
        component.selectedPipe.forEach((segment) => {
          const segmentId = component.getSegmentIdByName(segment);
          if (segmentId) {
            component.setItemColor(segmentId, component.inputs.colorDefault);
            component.setItemOpacity(segmentId, component.inputs.opacityDefault);
            if (component.animatedPipes.has(segmentId)) {
              component.setAnimatedPipeOpacity(segmentId, 0);
            }
            const segmentItem = component.getItem(segmentId);
            if (segmentItem) segmentItem.selected = false;
          }
        });
        component.selectedPipe = null;
      }

      selectedPipe.forEach((segment) => {
        const segmentId = component.getSegmentIdByName(segment);
        if (segmentId) {
          component.setItemColor(segmentId, component.inputs.colorClick);
          component.setItemOpacity(segmentId, component.inputs.opacityClick);
          if (component.animatedPipes.has(segmentId)) {
            component.setAnimatedPipeOpacity(segmentId, 1);
          }
          const segmentItem = component.getItem(segmentId);
          if (segmentItem) segmentItem.selected = true;
        }
      });

      component.selectedPipe = selectedPipe;
    }
  };

  component.selectedPipe = null;

  component.outputs.onPropertyChanged('loadingState', async (state: any) => {
    if (state === LoadingState.Loaded) {
      const menus = [];
      pipesConfig.pipes.forEach((pipe, index) => {
        const listItem = createMenuItem({ id: index, name: pipe.name, itemId: pipe.id });
        menus.push(listItem);
      });

      this.setState({ menus });
    }
  });

  if (this.iframe?.contentWindow?.location.href.includes('m=cKEUCfKQmHn')) {
    this.pipesData = await initPipesAmericanWater(
      this.showCaseTemp,
      this.modelNodes,
      this.state.polygons,
      this.renderer,
    );
  }
}
